import type { IconType } from "react-icons";
import { FaChartPie } from "react-icons/fa";
import { FiCalendar } from "react-icons/fi";
import { MdBarChart, MdNumbers } from "react-icons/md";
import { PiTarget } from "react-icons/pi";
import { Header } from "build-ts/metadata";
import { ColumnType, MetadataTypeEnum } from "build-ts/enums";

/** Matches ConfigurationPage entity nav: Metrics, Measures, Attributes, Datetime, Benchmarks (+ Metric). */
type OntologyEntityIconId = "metric" | "attribute" | "measure" | "benchmark" | "time";

export const ONTOLOGY_ENTITY_ICONS: Record<OntologyEntityIconId, IconType> = {
  metric: MdBarChart,
  attribute: FaChartPie,
  measure: MdNumbers,
  benchmark: PiTarget,
  time: FiCalendar,
};

export function ontologyIconForStep1(id: OntologyEntityIconId): IconType {
  return ONTOLOGY_ENTITY_ICONS[id];
}

export function iconForKgColumn(column_type: ColumnType | undefined): IconType {
  if (column_type === ColumnType.MEASURE) {
    return ONTOLOGY_ENTITY_ICONS.measure;
  }
  if (column_type === ColumnType.TEMPORAL) {
    return ONTOLOGY_ENTITY_ICONS.time;
  }
  return ONTOLOGY_ENTITY_ICONS.attribute;
}

/** Modal / page title when creating a KG entity of this type (type is fixed by entry point). */
export function kgCreateModalTitle(colType: ColumnType): string {
  if (colType === ColumnType.MEASURE) {
    return "Create Measure";
  }
  if (colType === ColumnType.TEMPORAL) {
    return "Create Time";
  }
  if (colType === ColumnType.ATTRIBUTE) {
    return "Create Attribute";
  }
  return "Create KG column";
}

/** Map page source column row: mapped entity icon. */
export function iconForMapRowSelection(header: Header): IconType {
  if (header.type === MetadataTypeEnum.METRIC) {
    return ONTOLOGY_ENTITY_ICONS.metric;
  }
  if (header.type === MetadataTypeEnum.BENCHMARK) {
    return ONTOLOGY_ENTITY_ICONS.benchmark;
  }
  return iconForKgColumn(header.column_type);
}
